import styled from 'styled-components';
import { ResponsiveHeading } from '../PageHeading/pageHeading.style';

export const DealRefreshModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Description = styled(ResponsiveHeading)`
    color: ${({ theme }) => theme.uiBricks?.secondaryFontColor || '#636569'};
`;

export const ButtonContainer = styled.div`
    margin: 0 auto;
    padding-top: 8px;

    button {
        width: auto;
        padding: 12px 66px;
        background-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'};
        border: none;
        font-family: 'Open Sans', sans-serif;
        font-weight: 600;
        font-size: 18px;
        color: ${({ theme }) => theme.tokens?.BaseColorWhite || '#ffffff'};

        &:hover {
            border-style: none;
        }
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: left;
`;
